export default __webpack_public_path__ + "static/media/candidate.work_learn_tab.plant_based.88baf8a6.jpg";